var map = {
	"./CanvasClear": 46,
	"./CanvasClear.js": 46,
	"./CanvasMove": 47,
	"./CanvasMove.js": 47,
	"./CommandAbstract": 23,
	"./CommandAbstract.js": 23,
	"./ComponentDelete": 48,
	"./ComponentDelete.js": 48,
	"./ComponentDrag": 49,
	"./ComponentDrag.js": 49,
	"./ComponentEnter": 50,
	"./ComponentEnter.js": 50,
	"./ComponentExit": 51,
	"./ComponentExit.js": 51,
	"./ComponentNext": 52,
	"./ComponentNext.js": 52,
	"./ComponentPrev": 53,
	"./ComponentPrev.js": 53,
	"./ComponentStyleClear": 54,
	"./ComponentStyleClear.js": 54,
	"./CopyComponent": 55,
	"./CopyComponent.js": 55,
	"./DeleteComponent": 56,
	"./DeleteComponent.js": 56,
	"./ExportTemplate": 57,
	"./ExportTemplate.js": 57,
	"./Fullscreen": 58,
	"./Fullscreen.js": 58,
	"./MoveComponent": 59,
	"./MoveComponent.js": 59,
	"./OpenAssets": 60,
	"./OpenAssets.js": 60,
	"./OpenBlocks": 61,
	"./OpenBlocks.js": 61,
	"./OpenLayers": 62,
	"./OpenLayers.js": 62,
	"./OpenStyleManager": 63,
	"./OpenStyleManager.js": 63,
	"./OpenTraitManager": 64,
	"./OpenTraitManager.js": 64,
	"./PasteComponent": 65,
	"./PasteComponent.js": 65,
	"./Preview": 66,
	"./Preview.js": 66,
	"./Resize": 67,
	"./Resize.js": 67,
	"./SelectComponent": 16,
	"./SelectComponent.js": 16,
	"./SelectPosition": 27,
	"./SelectPosition.js": 27,
	"./ShowOffset": 68,
	"./ShowOffset.js": 68,
	"./SwitchVisibility": 69,
	"./SwitchVisibility.js": 69
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92;